<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div
      class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden"
      style="padding-bottom: 20rem"
    >
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Revisión del estado de las fichas de registro
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
            >{{ filteredRaising.length }}</span
          >
        </h3>
        <button
          class="border-2 rounded border-gray-700"
          @click="changeRaisingOrder"
          v-tooltip.right="
            'Ordena tus fichas de forma ascendente o descendente'
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de fichas"
        class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full">
        <div class="w-full relative">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 mb-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
            @change="updateSelectRegister()"
          >
            <option selected value="-1">Todas</option>
            <template v-for="category in categories">
              <option :key="category.id" :value="category.id">
                {{ category.nombre }}
              </option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="w-full flex">
        <button
          v-on:click="
            (statusFilterRaising = 'TODOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-full hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'TODOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          Total de fichas {{ filteredRaisingByAll.length }}
        </button>
      </div>
      <div class="w-full flex">
        <button
          v-on:click="
            (statusFilterRaising = 'NO REVISADOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'NO REVISADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
          v-tooltip="'Fichas que enviaste para la aprobación del revisor'"
        >
          EN REVISIÓN {{ filteredRaisingByOpen.length }}
        </button>
        <button
          v-on:click="
            (statusFilterRaising = 'RECHAZADOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'RECHAZADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          RECHAZADAS {{ filteredRaisingByCanceled.length }}
        </button>
      </div>
      <div class="w-full flex pb-2">
        <button
          v-on:click="
            (statusFilterRaising = 'EN REVISIÓN'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-l border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'EN REVISIÓN'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
          v-tooltip="
            'Fichas a las que el revisor hizo comentarios para que realices los cambios pertinentes y pueda ser aprobada'
          "
        >
          EN MODIFICACIÓN {{ filteredRaisingByAssigned.length }}
        </button>
        <button
          v-on:click="
            (statusFilterRaising = 'APROBADOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'APROBADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          APROBADAS {{ filteredRaisingByAttended.length }}
        </button>
      </div>
      <div class="h-full overflow-auto">
        <div
          v-for="one_raising in filteredRaising"
          :key="one_raising.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{
            'bg-secondary-color': one_raising.id === currentRaising.id,
          }"
          @click="selectRaising(one_raising)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              one_raising.id === currentRaising.id
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-10 w-10 fill-current group-hover:text-gray-900 text-gray-100"
            viewBox="0 0 24 24"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
          <div class="flex flex-col flex-grow ml-2">
            <!-- <div class="w-1/2"> -->
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ one_raising.titulo }}</span
            >
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{
                one_raising.fecha_levantamiento | moment("DD/MM/YYYY hh:mm A")
              }}</span
            >
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-sm group-hover:text-gray-700"
              >F-{{ one_raising.id }}
              <span v-if="one_raising.status === 'EN REVISIÓN'"
                >EN MODIFICACIÓN</span
              >
              <span v-else>{{ one_raising.status }}</span>
            </span>
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-xs group-hover:text-gray-700"
              >{{ one_raising.cat_principal }}</span
            >
            <!-- </div> -->
          </div>
          <div
            v-if="one_raising.en_pausa === true"
            class="flex self-start justify-self-end text-xs"
          >
            <div
              class="px-3 py-1 rounded-full border-2 border-blue-700 text-xs text-white bg-blue-500"
            >
              En pausa
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="w-full pb-2 text-right">
            <!--             <button
              v-if="downloadActive && currentProject.status === 'APROBADO'"
              v-on:click="showingConfirmDownload = true"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Descargar Fichas
            </button>
            <button
              v-on:click="exportPDF()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Descargar Reporte
            </button> -->
            <!--             <button
              v-if="
                currentProject.status === 'NO REVISADO' ||
                currentProject.status === 'EN REVISIÓN'
              "
              v-on:click="newChatModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Mensajes
            </button> -->
            <!--             <button
              v-if="currentProject.status !== 'APROBADO'"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="openEditModal()"
            >
              Editar
            </button> -->
            <!--             <button
              v-if="currentProject.activo"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="showingDeactivationConfirm = true"
            >
              Desactivar
            </button>
            <button
              v-if="currentProject.activo === false"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="showingActivationConfirm = true"
            >
              Activar
            </button> -->
            <button
              v-if="
                (currentRaising.status === 'APROBADO' &&
                  email === currentRaising.email_curador) ||
                (currentRaising.status === 'APROBADO' &&
                  category === 'ADMINISTRADOR')
              "
              class="bg-transparent hover:bg-orange-500 text-orange-500 font-semibold hover:text-white py-2 px-4 mx-1 border border-orange-500 hover:border-transparent rounded"
              @click="showingDisaproveConfirm = true"
            >
              Desaprobar
            </button>

            <button
              v-if="category === 'ADMINISTRADOR'"
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingDeleteConfirm = true"
            >
              Eliminar
            </button>
          </div>

          <alert-dialog :showing="showingDisaproveConfirm">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                ¿Realmente desea desaprobar esta ficha? Pasará de nuevo a
                revisión y ya no será visible en el mapa y buscador hasta que se
                apruebe de nuevo.
              </div>
            </div>
            <div class="w-full flex items-center justify-center">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-orange-500 border-4 font-bold tracking-wider bg-white hover:bg-orange-300"
                @click="desaprobarFicha()"
              >
                Desaprobar
              </button>
              <button
                class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingDisaproveConfirm = false"
              >
                Cancelar
              </button>
            </div>
          </alert-dialog>

          <alert-dialog :showing="showingSuccessDisaprove">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                Ficha desaprobada exitosamente
              </div>
              <div class="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
                  viewBox="0 0 24 24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                  />
                </svg>
              </div>
            </div>
            <div class="w-full">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingSuccessDisaprove = false"
              >
                Cerrar
              </button>
            </div>
          </alert-dialog>

          <alert-dialog :showing="showingDeleteConfirm">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                ¿Realmente desea ELIMINAR esta ficha? se eliminará por completo
                del sistema. Esta acción no se puede deshacer
              </div>
            </div>
            <div class="w-full flex items-center justify-center">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
                @click="eliminarFicha()"
              >
                Eliminar
              </button>
              <button
                class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingDeleteConfirm = false"
              >
                Cancelar
              </button>
            </div>
          </alert-dialog>

          <alert-dialog :showing="showingSuccessDelete">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                Ficha eliminada exitosamente
              </div>
              <div class="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
                  viewBox="0 0 24 24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                  />
                </svg>
              </div>
            </div>
            <div class="w-full">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingSuccessDelete = false"
              >
                Cerrar
              </button>
            </div>
          </alert-dialog>

          <div class="flex">
            <h1
              class="pb-1 text-left font-bold tracking-widest text-neutral-100"
            >
              {{ currentRaising.cat_principal }}
            </h1>
          </div>
          <div class="flex">
            <div class="h-80 w-full">
              <l-map
                ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="4"
                :center="center"
                :options="{ zoomControl: true }"
                @ready="onMapReady"
              >
                <!-- <l-geo-json :geojson="polygon" :options-style="geoStyle" /> -->
                <l-tile-layer
                  :url="urlBasemap"
                  :attribution="attribution"
                ></l-tile-layer>
                <l-marker :lat-lng="center" :visible="showMarker"></l-marker>
              </l-map>
            </div>
          </div>
          <div class="flex w-full">
            <div
              class="flex flex-col w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <div class="flex items-center">
                <div class="flex items-center w-1/2 text-left text-xs">
                  <div
                    v-if="currentRaising.status === 'NO REVISADO'"
                    class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} EN REVISIÓN
                  </div>
                  <div
                    v-if="currentRaising.status === 'RECHAZADO'"
                    class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} {{ currentRaising.status }}
                  </div>
                  <div
                    v-if="currentRaising.status === 'EN REVISIÓN'"
                    class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} EN MODIFICACIÓN
                  </div>
                  <div
                    v-if="currentRaising.status === 'APROBADO'"
                    class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} {{ currentRaising.status }}
                  </div>
                  <!-- <svg
                    class="ml-4 cursor-pointer"
                    @click="showRaisingChatModal(currentRaising)"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    />
                  </svg> -->
                  <button
                    v-if="currentRaising.id_proyecto != null"
                    v-on:click="showProjectDetailModal()"
                    class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-1 px-4 mx-1 mt-0 border border-secondary-color-dark hover:border-transparent rounded"
                  >
                    ver proyecto
                  </button>
                </div>
                <div class="w-1/2 text-right text-xs text-gray-900">
                  {{
                    currentRaising.fecha_levantamiento
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>
              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Título:</span>
                </div>
                <div
                  class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.title }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del registrante:</span>
                </div>
                <div
                  class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.nombre }} {{ currentRaising.apellido }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
                v-if="currentRaising.id_curador !== null"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span
                    class="font-bold"
                    v-if="currentRaising.status !== 'NO REVISADO'"
                    >Atendido por:</span
                  >
                </div>
                <div
                  class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.nombre_curador }}
                  {{ currentRaising.apellido_curador }}
                </div>
              </div>

              <div
                class="flex flex-wrap w-full item-center justify-center px-3 mb-6 md:mb-0"
              >
                <template v-if="list_path_media_folder !== []">
                  <template
                    v-for="(
                      path_media_folder, mediaIndex
                    ) in list_path_media_folder"
                  >
                    <div
                      class="w-1/2 item-center justify-center"
                      :key="mediaIndex"
                    >
                      <div class="w-full p-2">
                        <video
                          v-if="path_media_folder.mimeType == 'video/mp4'"
                          :src="replaceURL(path_media_folder.fileName, 'video')"
                          width="640"
                          height="480"
                          controls
                          controlslist="nodownload"
                        />
                        <v-lazy-image
                          v-if="
                            path_media_folder.mimeType == 'image/jpeg' ||
                            path_media_folder.mimeType == 'image/png'
                          "
                          :src="replaceURL(path_media_folder.fileName, 'img')"
                        />
                      </div>
                    </div>
                  </template>
                </template>
              </div>

              <div
                v-if="
                  currentRaising.isfromgallery !== null &&
                  currentRaising.isfromgallery == true
                "
              >
                <span style="color: red; font-size: small">
                  *Las imágenes provienen de la galería del usuario
                </span>
              </div>

              <div
                v-if="
                  currentRaising.insitu !== null &&
                  currentRaising.insitu == false
                "
              >
                <span style="color: red; font-size: small">
                  **El usuario señaló que no se encontraba en el sitio al
                  momento de llenar la ficha
                </span>
              </div>

              <p class="pb-1 pt-2 text-sm text-left font-bold tracking-widest">
                Ficha de información:
              </p>
              <!-- Ficha de información-->
              <div
                v-for="one_question in currentQuestions"
                :key="one_question.id"
              >
                <div v-if="one_question.texto != null">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    >{{ one_question.id_pregunta }}.-
                    {{ one_question.texto }}</label
                  >

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->
                  <div v-if="one_question.tipo === 'ABIERTA'">
                    <textarea
                      v-if="one_question.tipo === 'ABIERTA'"
                      class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      :value="one_question.respuesta"
                      disabled
                    />
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->
                  <div v-else-if="one_question.tipo === 'MULTISELECCION'">
                    <template
                      v-for="(id_key, answer) in one_question.respuesta
                        .opciones"
                    >
                      <input
                        v-if="id_key === true"
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="answer"
                        disabled
                      />
                    </template>

                    <div
                      v-if="
                        one_question.respuesta.otro != null &&
                        one_question.respuesta.otro != ''
                      "
                      class="flex items-left text-gray-700 font-bold"
                      style="align-items: baseline"
                    >
                      Otro: &nbsp; &nbsp;
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="one_question.respuesta.otro"
                        disabled
                      />
                    </div>

                    <template
                      v-if="
                        one_question.respuesta.hasOwnProperty('subpregunta')
                      "
                    >
                      <template
                        v-for="(answer, index) in one_question.respuesta
                          .subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer.id_pregunta }}.- {{ answer.texto }}</label
                        >

                        <template v-if="answer.tipo == 'SELECCION'">
                          <template
                            v-if="answer.respuesta.selected_answer != 'Otro'"
                          >
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer"
                              disabled
                            />
                          </template>

                          <template v-else>
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="
                                answer.respuesta.selected_answer +
                                ': ' +
                                answer.respuesta.otro
                              "
                              disabled
                            />
                          </template>
                        </template>

                        <template v-if="answer.tipo == 'ABIERTA'">
                          <textarea
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer.respuesta"
                            disabled
                          />
                        </template>

                        <template v-if="answer.tipo == 'CAMPOS'">
                          <template v-for="(id_key, label) in answer.respuesta">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->
                  <div
                    v-else-if="one_question.tipo === 'SELECCION_CONDICIONAL'"
                  >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      :value="one_question.respuesta.selected_answer"
                      disabled
                    />

                    <template
                      v-if="
                        one_question.respuesta.conditional_answer.hasOwnProperty(
                          one_question.respuesta.selected_answer
                        )
                      "
                    >
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].id
                        }}.-
                        {{
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].texto
                        }}</label
                      >

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'ABIERTA'
                        "
                      >
                        <textarea
                          class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta
                          "
                          disabled
                        />

                        <template
                          v-if="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].hasOwnProperty('subpregunta')
                          "
                        >
                          <template
                            v-for="(opt, index) in one_question.respuesta
                              .conditional_answer[
                              one_question.respuesta.selected_answer
                            ].subpregunta"
                          >
                            <label
                              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >
                              {{ opt.id_pregunta }}.-
                              {{ opt.texto }}
                            </label>

                            <template v-if="opt.tipo == 'SELECCION'">
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="opt.respuesta"
                                disabled
                              />
                            </template>
                          </template>
                        </template>
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'MULTISELECCION'
                        "
                      >
                        <template
                          v-for="(id_key, answer) in one_question.respuesta
                            .conditional_answer[
                            one_question.respuesta.selected_answer
                          ].respuesta.opciones"
                        >
                          <input
                            v-if="id_key === true"
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer"
                            disabled
                          />
                        </template>

                        <template
                          v-if="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta.otro != ''
                          "
                        >
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="
                              'Otro:' +
                              ' ' +
                              one_question.respuesta.conditional_answer[
                                one_question.respuesta.selected_answer
                              ].respuesta.otro
                            "
                            disabled
                          />
                        </template>
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'SELECCION'
                        "
                      >
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta
                          "
                          disabled
                        />
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo === 'CAMPOS'
                        "
                      >
                        <template
                          v-for="(id_key, answer) in one_question.respuesta
                            .conditional_answer[
                            one_question.respuesta.selected_answer
                          ].respuesta"
                        >
                          <div class="flex w-full items-center justify-center">
                            <label
                              class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ answer }}</label
                            >
                            <input
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="id_key"
                              disabled
                            />
                          </div>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->
                  <div v-else-if="one_question.tipo === 'SELECCION'">
                    <template
                      v-if="one_question.respuesta.selected_answer != 'Otro'"
                    >
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="one_question.respuesta.selected_answer"
                        disabled
                      />
                    </template>
                    <template v-else>
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="
                          one_question.respuesta.selected_answer +
                          ': ' +
                          one_question.respuesta.otro
                        "
                        disabled
                      />
                    </template>

                    <template
                      v-if="
                        one_question.respuesta.hasOwnProperty('subpregunta')
                      "
                    >
                      <template
                        v-for="(answer, index) in one_question.respuesta
                          .subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer.id_pregunta }}.- {{ answer.texto }}</label
                        >

                        <template v-if="answer.tipo == 'SELECCION'">
                          <template
                            v-if="answer.respuesta.selected_answer != 'Otro'"
                          >
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer"
                              disabled
                            />
                          </template>

                          <template v-else>
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="
                                answer.respuesta.selected_answer +
                                ' ' +
                                answer.respuesta.otro
                              "
                              disabled
                            />
                          </template>
                        </template>

                        <template v-if="answer.tipo == 'ABIERTA'">
                          <textarea
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer.respuesta"
                            disabled
                          />
                        </template>

                        <template v-if="answer.tipo == 'CAMPOS'">
                          <template v-for="(id_key, label) in answer.respuesta">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO CAMPOS -->
                  <div v-else-if="one_question.tipo === 'CAMPOS'">
                    <template
                      v-for="(id_key, answer) in one_question.respuesta"
                    >
                      <div class="flex w-full items-center justify-center">
                        <label
                          class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer }}</label
                        >
                        <input
                          class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="id_key"
                          disabled
                        />
                      </div>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO CAMPOS -->

                  <div v-else>Ninguna de las anteriores</div>
                </div>
              </div>
              <!-- /Ficha de información-->
            </div>
          </div>
        </div>
        <div v-if="category != 'ADMINISTRADOR'">
          <button
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              (currentRaising.status === 'EN REVISIÓN' &&
                email === currentRaising.email_curador)
            "
            v-on:click="updateStatusModal('APROBADO', 'APROBAR')"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            APROBAR
          </button>
          <button
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              (currentRaising.status === 'EN REVISIÓN' &&
                email === currentRaising.email_curador)
            "
            v-on:click="updateStatusModal('RECHAZADO', 'RECHAZAR')"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            RECHAZAR
          </button>
          <button
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              (currentRaising.status === 'EN REVISIÓN' &&
                email === currentRaising.email_curador)
            "
            v-on:click="newChatModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            MENSAJES
          </button>
          <!--             <button 
              v-if = "currentRaising.status === 'NO REVISADO' || (currentRaising.status === 'EN REVISIÓN' && email === currentRaising.email_curador)"
              v-on:click="updateQuestionsModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >EDITAR</button> -->
          <!-- <button
              v-if = "currentRaising.status === 'NO REVISADO' || (currentRaising.status === 'EN REVISIÓN' && email === currentRaising.email_curador)"
              v-on:click="updateStatusModal('EN REVISIÓN','DEVOLVER')"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >DEVOLVER</button>  -->
        </div>

        <div v-if="category == 'ADMINISTRADOR'">
          <button
            v-on:click="newChatModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            VER MENSAJES
          </button>
        </div>
      </div>
    </div>

    <raising-modal
      :showing="showRaisingModal"
      @close="showRaisingModal = false"
      @updateAllRaising="fetchRaising"
    ></raising-modal>

    <raising-chat-modal
      :showing="showCommentsModal"
      @close="closeChatModal"
    ></raising-chat-modal>

    <project-detail-modal
      :showing="showProjectDetail"
      @close="showProjectDetail = false"
    ></project-detail-modal>

    <user-raising-update-questions-modal
      :showing="showUpdateQuestionsModal"
      @close="closeUpdateQuestionsModal()"
      @updateQuestions="updateQuestions()"
    ></user-raising-update-questions-modal>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import moment from "moment";
import AlertDialog from "./AlertDialog";
/* import polygon from "../assets/polygonChapp.json"; */
import L from "leaflet";
import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import { Icon } from "leaflet";
import EventBus from "../event-bus";
import RaisingModal from "./RaisingModal";
import RaisingChatModal from "./RaisingChatModal";
import ProjectDetailModal from "./ProjectDetailModal.vue";
import UserRaisingUpdateQuestionsModal from "./UserRaisingUpdateQuestionsModal";

export default {
  name: "raising-list",
  data() {
    return {
      categories: null,
      raising: [],
      currentRaising: {},
      currentQuestions: [],
      list_path_media_folder: [],
      search: "",
      raisingOrder: "downward",
      statusFilterRaising: "NO REVISADOS",
      email: localStorage.getItem("email"),
      category: localStorage.getItem("category"),
      showUpdateQuestionsModal: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      showingError: false,
      /* polygon: polygon, */
      zoom: 12,
      center: [20.58651, -89.01501],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false,
      },
      chatRaising: null,
      chartList: null,
      showChatModal: false,
      showRaisingModal: false,
      showCommentsModal: false,
      showProjectDetail: false,
      showingDisaproveConfirm: false,
      showingSuccessDisaprove: false,
      showingDeleteConfirm: false,
      showingSuccessDelete: false,
      categoryFilter: "-1",
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    AlertDialog,
    RaisingModal,
    RaisingChatModal,
    ProjectDetailModal,
    UserRaisingUpdateQuestionsModal,
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.name) {
      this.statusFilterRaising = "TODOS";
      let id = this.$route.query.id.toString();
      let name = this.$route.query.name.toString();
      this.search = `${id} ${name}`;
    }

    EventBus.$emit("updateNotification", {});
    this.fetchRaising();
    this.fetchCategories();
  },
  methods: {
    onMapReady: function () {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
      });
    },

    updateSelectRegister() {
      if (this.filteredRaising.length > 0) {
        this.selectRaising(this.filteredRaising[0]);
      }
    },

    fetchCategories() {
      this.categories = [];
      this.axios
        .get("apidev/levantamientos/getCategorias", {}, this.config)
        .then((response) => {
          //this.categories = response.data;
          response.data.forEach((element) => {
            if (
              element.nombre != "Patrimonio material" &&
              element.nombre != "Patrimonio inmaterial"
            ) {
              this.categories.push(element);
            }
          });
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },

    fetchRaising() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosGeneral",
          {
            email: this.email,
            category: this.category,
          },
          this.config
        )
        .then((response) => {
          this.raising = response.data.levantamientos;
          this.$root.$emit("hideLoading");
          if (this.filteredRaising.length > 0) {
            this.selectRaising(this.filteredRaising[0]);
          }
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    updateQuestions() {
      this.selectRaising(this.currentRaising);
    },
    closeUpdateQuestionsModal() {
      this.showUpdateQuestionsModal = false;
    },
    selectRaising(raising) {
      this.$root.$emit("showLoading");
      this.list_path_media_folder = [];
      this.currentRaising = raising;
      console.log(this.currentRaising);

      if (raising.latitud !== null && raising.longitud !== null) {
        this.center = [raising.latitud, raising.longitud];
        this.showMarker = true;
      } else {
        this.showMarker = false;
      }

      /* this.axios
        .post(
          "../apidev/levantamientos/media/list",
          {
            id: this.currentRaising.id,
          },
          this.config
        )
        .then((response) => {
          console.log(response);
          this.list_path_media_folder = JSON.parse(
            response.data.list.path_media_folder
          );
          return this.axios.post(
            "../apidev/levantamientos/getFichaRespuestasJson",
            {
              id_levantamiento: this.currentRaising.id,
            },
            this.config
          );
        })
        .then((response) => {
          this.currentQuestions = response.data.answers;
          console.log(this.currentQuestions);
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        }); */
      this.axios
        .post(
          "../apidev/levantamientos/getFichaRespuestasJson",
          {
            id_levantamiento: this.currentRaising.id,
          },
          this.config
        )
        .then((response) => {
          this.currentQuestions = response.data.answers;
          console.log(this.currentQuestions);
          this.list_path_media_folder = JSON.parse(
            this.currentRaising.path_media_folder
          );
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;

          this.list_path_media_folder = JSON.parse(
            this.currentRaising.path_media_folder
          );

          this.$root.$emit("hideLoading");
        });
    },

    changeRaisingOrder() {
      this.raisingOrder =
        this.raisingOrder === "upward" ? "downward" : "upward";
    },

    updateStatusModal(status, label) {
      this.showRaisingModal = true;
      EventBus.$emit("statusModal", {
        raising_id: this.currentRaising.id,
        status: status,
        label: label,
        menu: "LEVANTAMIENTO",
      });
    },

    newChatModal() {
      this.showCommentsModal = true;
      let showNewMessageButton = true;
      let is_curador = true;
      if (this.category == "ADMINISTRADOR") {
        showNewMessageButton = false;
        is_curador = false;
      }
      EventBus.$emit("showChatModal", {
        raising_id: parseInt(this.currentRaising.id),
        userficha_id: this.currentRaising.usuario_id,
        is_curador: is_curador,
        showNewMessageButton: showNewMessageButton,
        menu: "LEVANTAMIENTO",
      });
    },
    closeChatModal() {
      this.showCommentsModal = false;
      //this.fetchRaising();
    },
    joinCategories(opciones) {
      let string_categories = "";
      for (const property in opciones) {
        if (opciones[property]) {
          string_categories += property + ", ";
        }
      }

      return string_categories;
    },

    showProjectDetailModal() {
      this.showProjectDetail = true;
      EventBus.$emit("showProjectDetail", {
        id_proyecto: this.currentRaising.id_proyecto,
      });
    },

    desaprobarFicha() {
      console.log(this.currentRaising);
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/levantamientos/desaprobarLevantamiento/" +
            this.currentRaising.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false",
          },
          this.config
        )
        .then((response) => {
          console.log("Ficha desaprobada");

          this.showingDisaproveConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDisaprove = true;

          //guarda bitácora
          let name = localStorage.getItem("name");
          let user_id = localStorage.getItem("user_id");

          //console.log(name+" cambió el rol de invitación para "+this.guestUser.email+" de "+oldRol+" a "+this.guestUser.name_category)

          this.axios
            .post(
              "/apidev/bitacoras/save/",
              {
                module: "Revisión de fichas",
                action: "Ficha desaprobada",
                observation:
                  name +
                  " desaprobó la ficha con folio F-" +
                  this.currentRaising.id +
                  " (" +
                  this.currentRaising.title +
                  ")",
                email: localStorage.getItem("email"),
                user_id: localStorage.getItem("user_id"),
              },
              this.config
            )
            .then((response) => {
              //console.log(response)
            })
            .catch((error) => {
              console.log(error);
            });
          //FIN guarda bitácora

          this.fetchRaising();
          //console.log(response)
          //console.log(response["data"]["status"])
          /*           if(response["data"]["status"] == "Proyecto eliminado"){
            this.currentProject = {};
            this.fetchProjects();
            this.search = "";
            this.showingDisaproveConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessDelete = true;            
          }
          if(response["data"]["status"] == "El proyecto tiene fichas asociadas"){
            this.showingDisaproveConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingProjectNotEmpty = true;            
          }   */
          /*           this.currentProject = {};
          this.fetchProjects();
          this.search = "";
          this.showingDeactivationConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDeactivation = true; */
        })
        .catch((error) => {
          //this.catchError(error);
          console.log("ocurrió un error al desaprobar: ", error);
          this.showingDisaproveConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },

    eliminarFicha() {
      console.log(this.currentRaising);

      this.$root.$emit("showLoading");
      this.axios
        .delete(
          "../apidev/levantamientos/deleteLevantamiento/" +
            this.currentRaising.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false",
          },
          this.config
        )
        .then((response) => {
          console.log("Ficha eliminada");

          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDelete = true;

          //guarda bitácora
          let name = localStorage.getItem("name");
          let user_id = localStorage.getItem("user_id");

          //console.log(name+" cambió el rol de invitación para "+this.guestUser.email+" de "+oldRol+" a "+this.guestUser.name_category)

          this.axios
            .post(
              "/apidev/bitacoras/save/",
              {
                module: "Revisión de fichas",
                action: "Ficha eliminada",
                observation:
                  name +
                  " eliminó la ficha con folio F-" +
                  this.currentRaising.id +
                  " (" +
                  this.currentRaising.title +
                  ")",
                email: localStorage.getItem("email"),
                user_id: localStorage.getItem("user_id"),
              },
              this.config
            )
            .then((response) => {
              //console.log(response)
            })
            .catch((error) => {
              console.log(error);
            });
          //FIN guarda bitácora

          this.fetchRaising();
        })
        .catch((error) => {
          //this.catchError(error);
          console.log("ocurrió un error al eliminar: ", error);
          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },

    replaceURL(path, type) {
      if (type === "video") {
        return path.replace("./", "apidev/");
      } else {
        let lastIndex = path.lastIndexOf(".");
        let beforeStr = path.slice(0, lastIndex);
        let afterStr = path.slice(lastIndex + 1);
        let resizePath = beforeStr + "_resize." + afterStr;
        return resizePath.replace("./", "apidev/");
      }
    },
    updateQuestionsModal() {
      this.showUpdateQuestionsModal = true;
      EventBus.$emit("updateQuestionsModal", {
        id: parseInt(this.currentRaising.id),
        id_project: this.currentRaising.id_proyecto,
        id_cat_principal: parseInt(this.currentRaising.id_cat_principal),
        curret_questions: this.currentQuestions,
        editQuestion: true,
      });
    },
    closeUpdateQuestionsModal() {
      this.showUpdateQuestionsModal = false;
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
  },
  computed: {
    filteredRaising() {
      return this.raising
        .filter((elem) => {
          let date = moment(elem.fecha_levantamiento).format("DD/MM/YYYY");

          let new_string_search = `${date.toLowerCase()} ${elem.id.toString()} ${elem.titulo.toLowerCase()}`;
          switch (this.statusFilterRaising) {
            case "TODOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "RECHAZADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "RECHAZADO" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "NO REVISADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "NO REVISADO" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "EN REVISIÓN":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "EN REVISIÓN" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "APROBADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "APROBADO" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.raisingOrder === "upward") {
            return (
              new Date(a.fecha_levantamiento) - new Date(b.fecha_levantamiento)
            );
          } else {
            return (
              new Date(b.fecha_levantamiento) - new Date(a.fecha_levantamiento)
            );
          }
        });
    },
    filteredRaisingByAll() {
      return this.raising.filter(
        (elem) =>
          this.categoryFilter === "-1" ||
          parseInt(elem.id_cat_principal) === this.categoryFilter
      );
    },
    filteredRaisingByOpen() {
      return this.raising.filter(
        (elem) =>
          elem.status == "NO REVISADO" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },
    filteredRaisingByAssigned() {
      return this.raising.filter(
        (elem) =>
          elem.status == "EN REVISIÓN" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },
    filteredRaisingByCanceled() {
      return this.raising.filter(
        (elem) =>
          elem.status == "RECHAZADO" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },
    filteredRaisingByAttended() {
      return this.raising.filter(
        (elem) =>
          elem.status == "APROBADO" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },

    //NO REVISADO, EN REVISION, APROBADO, RECHAZADO
  },
};
</script>

<style scoped>
textarea {
  resize: none;
}

.textareaficha {
  resize: vertical;
  text-align: justify;
  height: auto;
}
</style>
